import styled, { css } from 'styled-components'
import { media } from '../../layouts/utils'
import {
  colorBrandPrimary,
  colorNeutral,
  fontFamily,
  fontSize,
} from '../../global.style'

export const ExternalLink = styled.a`
  color: ${(props) =>
    props.dark ? colorBrandPrimary.marine : colorNeutral.light};
  font-family: ${fontFamily.brand};
  font-size: ${(props) => (props.small ? fontSize.xxs : fontSize.xs)};
  height: ${(props) => props.img && '24px'};
  cursor: pointer;
  text-align: ${(props) => (props.center ? 'center' : 'start')};
  text-decoration: none;
  /* width: ${(props) => props.img && '24px'}; */

  ${(props) =>
    props.botaoEmbaixo &&
    css`
      align-self: center;
      ${media.desktop`
              padding-top: 24px;
          `}
    `}
`
